import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useState } from "react";
import { Distribution, DistributionCauseArea, Donation } from "../../../../models";
import { Organization } from "../../../shared/components/Widget/types/Organization";
import style from "./DonationImpact.module.scss";
import ghStyle from "./GlobalHealth/DonationImpactGlobalHealth.module.scss";
import { DonationImpactGlobalHealthItem, ImpactItemConfiguration } from "./GlobalHealth/DonationImpactItemGlobalHealth";
import DonationImpactGlobalHealth from "./GlobalHealth/DonationImpactGlobalHealth";
import DonationImpactAnimalWelfare from "./AnimalWelfare/DonationImpactAnimalWelfare";
import { mapNameToOrgAbbriv } from "../../../../util/mappings";
export type DonationImpactItemsConfiguration = {
  currency: string;
  locale: string;
  operations_label: string;
  impact_item_configuration: ImpactItemConfiguration;
};
const DonationImpact: React.FC<{
  donation: Donation;
  distribution: Distribution;
  timestamp: Date;
  configuration: DonationImpactItemsConfiguration;
  organizations: Organization[];
}> = t0 => {
  const $ = _c(31);
  const {
    donation,
    distribution,
    timestamp,
    configuration,
    organizations
  } = t0;
  const [requiredPrecision, setRequiredPrecision] = useState(0);
  let t1;
  if ($[0] !== requiredPrecision) {
    t1 = precision => {
      if (precision > requiredPrecision) {
        setRequiredPrecision(precision);
      }
    };
    $[0] = requiredPrecision;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const updatePrecision = t1;
  if (donation.impact?.length) {
    let t2;
    if ($[2] !== configuration || $[3] !== donation.id || $[4] !== donation.impact || $[5] !== organizations || $[6] !== requiredPrecision || $[7] !== timestamp || $[8] !== updatePrecision) {
      let t3;
      if ($[10] !== configuration || $[11] !== donation.id || $[12] !== organizations || $[13] !== requiredPrecision || $[14] !== timestamp || $[15] !== updatePrecision) {
        t3 = (entry, i) => {
          const matchedOrg = organizations.find(org => org.name === entry.organization);
          if (!matchedOrg) {
            console.error(`No organization found matching DK impact organization "${entry.organization}"`);
          }
          return <DonationImpactGlobalHealthItem key={`${donation.id}-impact-${i}`} orgAbriv="" orgName={entry.recipient} sumToOrg={entry.amount} donationTimestamp={timestamp} precision={requiredPrecision} signalRequiredPrecision={updatePrecision} configuration={configuration.impact_item_configuration} preComputedImpact={{
            output: entry.count,
            shortDescription: entry.unit,
            longDescription: matchedOrg?.shortDescription ?? "",
            charityName: entry.recipient,
            orgUrl: matchedOrg?.informationUrl ?? ""
          }} />;
        };
        $[10] = configuration;
        $[11] = donation.id;
        $[12] = organizations;
        $[13] = requiredPrecision;
        $[14] = timestamp;
        $[15] = updatePrecision;
        $[16] = t3;
      } else {
        t3 = $[16];
      }
      t2 = donation.impact.map(t3);
      $[2] = configuration;
      $[3] = donation.id;
      $[4] = donation.impact;
      $[5] = organizations;
      $[6] = requiredPrecision;
      $[7] = timestamp;
      $[8] = updatePrecision;
      $[9] = t2;
    } else {
      t2 = $[9];
    }
    let t3;
    if ($[17] !== t2) {
      t3 = <div className={ghStyle.container}><table className={ghStyle.wrapper} cellSpacing={0} data-cy="donation-impact-list"><tbody>{t2}</tbody></table></div>;
      $[17] = t2;
      $[18] = t3;
    } else {
      t3 = $[18];
    }
    return t3;
  }
  let t2;
  if ($[19] !== configuration || $[20] !== distribution.causeAreas || $[21] !== donation || $[22] !== timestamp) {
    let t3;
    if ($[24] !== configuration || $[25] !== distribution.causeAreas.length || $[26] !== donation || $[27] !== timestamp) {
      t3 = causeArea => <div key={`${donation.id}-causarea${causeArea.id}-impact`}>{distribution.causeAreas.length > 1 && <h5 className={style.causeAreaHeader}>{causeArea.name}</h5>}{causeArea.id === 1 && <DonationImpactGlobalHealth key={`${donation.id}-causarea${causeArea.id}-impact`} donation={donation} distribution={causeArea.organizations.map(org_0 => ({
          org: mapNameToOrgAbbriv(org_0.name as string),
          orgName: org_0.name ?? "unknown",
          sum: parseFloat(donation.sum) * (parseFloat(org_0.percentageShare) / 100) * (parseFloat(causeArea.percentageShare) / 100)
        }))} timestamp={timestamp} configuration={configuration} />}{causeArea.id !== 1 && <DonationImpactAnimalWelfare key={`${donation.id}-causarea${causeArea.id}-impact`} donation={donation} distribution={causeArea.organizations.map(org_1 => ({
          org: org_1.name as string,
          sum: parseFloat(donation.sum) * (parseFloat(org_1.percentageShare) / 100) * (parseFloat(causeArea.percentageShare) / 100)
        }))} timestamp={timestamp} configuration={configuration} />}</div>;
      $[24] = configuration;
      $[25] = distribution.causeAreas.length;
      $[26] = donation;
      $[27] = timestamp;
      $[28] = t3;
    } else {
      t3 = $[28];
    }
    t2 = distribution.causeAreas.map(t3);
    $[19] = configuration;
    $[20] = distribution.causeAreas;
    $[21] = donation;
    $[22] = timestamp;
    $[23] = t2;
  } else {
    t2 = $[23];
  }
  let t3;
  if ($[29] !== t2) {
    t3 = <>{t2}</>;
    $[29] = t2;
    $[30] = t3;
  } else {
    t3 = $[30];
  }
  return t3;
};
export default DonationImpact;